import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

import { gridSpacing } from 'store/constant';

import img404 from 'assets/images/maintenance/404-transparent.png';

const ErrorCard = styled(Card)({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

export default function DeploymentNotFound() {

    return (
        <ErrorCard>
            <CardContent>
                <Grid container justifyContent="center" spacing={gridSpacing} alignItems="center" sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}>
                    <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
                        <Typography
                            variant="h1"
                            className="main-font-b"
                            sx={{ fontSize: { xs: '72px', sm: '110px', md: '130px' }, lineHeight: 0.9, textShadow: '3px -1px 4px #1e9a83' }}
                        >
                            404
                        </Typography>
                        <Typography variant="h1" className="main-font-b" sx={{ fontSize: { xs: '34px', md: '50px' } }}>
                            Client Not Found
                        </Typography>
                        <Typography variant="body1" className="main-font" sx={{ mb: 1.5 }}>
                            We could not find a client deployment for this RPL Robot portal.
                        </Typography>
                        <Typography variant="body1" className="main-font" color="text.secondary" sx={{ mb: 3 }}>
                            Please check the portal link or contact your administrator.
                        </Typography>
                        <Box sx={{ width: '100px', height: '3px', background: '#1f9980', margin: 'auto' }} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box component="img" src={img404} draggable={false} alt="client-not-found" sx={{ width: { md: '500px', xs: '100%' } }} />
                    </Grid>
                </Grid>
            </CardContent>
        </ErrorCard>
    );
}
